/**
 * 人工审批暂停横幅：pending_approval / awaitingApproval → 确认并续跑。
 */
import { escapeHtml } from './util/html.js';

/** 是否处于人工审批暂停 */
export function isAwaitingApproval(result) {
  if (!result) return false;
  if (result.awaitingApproval === true) return true;
  const decision = result.decision?.result || result.decisionResult;
  return decision === 'pending_approval';
}

/** 生成审批横幅 HTML（确认并续跑 → POST .../resume） */
export function buildApprovalBannerHtml(runId) {
  if (!runId) return '';
  return `
      <div class="approval-banner">
        <div class="approval-hint">
          <strong>等待人工审批（投委决策节点）</strong>
          <div style="margin-top:4px;">Workflow 已暂停。审阅后点击确认，将从 Checkpoint 续跑。</div>
        </div>
        <button type="button" class="btn-primary" data-resume-run="${escapeHtml(runId)}">确认并续跑</button>
      </div>`;
}

/** 更新 p2 固定审批横幅显隐与 runId */
export function updateP2ApprovalBanner(result) {
  const banner = document.getElementById('approval-banner-p2');
  const button = document.getElementById('approval-resume-p2');
  if (!banner || !button) return;
  if (isAwaitingApproval(result) && result.runId) {
    banner.hidden = false;
    banner.style.display = 'flex';
    button.setAttribute('data-resume-run', result.runId);
  } else {
    banner.hidden = true;
    banner.style.display = 'none';
    button.setAttribute('data-resume-run', '');
  }
}
